import React, { Component } from 'react';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Button from 'react-validation/build/button';
import './../../custom.css';
import './../../pages/invoice.css';
import validator from 'validator';

let InputStaticClass="regInput ";
let AddedClass="";

  const required = (value) => {
    if (!value.toString().trim().length) {
      // We can return string or jsx as the 'error' prop for the validated Component
      return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> This field is required.</div>;
    }
  };
  const quantityRule = (value) => {
    //isDecimal(str [, options])
    //isInt(str [, options])
    // 
    if (!validator.isInt(value.toString(), {min: 1, max: 100}) ) {
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid integer between 1 and 100</div>;
    }
};
  const FullName = (value,props) => {
      var patt = new RegExp("[a-zA-Zا-ى]+ [a-zA-Zا-ى]+");
      if(!patt.test(value) || value[0] === " " || value[value.length - 1] === " "){
          return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter your full name.</div>;
      }
      else{
        AddedClass="success";
        document.getElementById(props.id).className= InputStaticClass + AddedClass;
     }
  };
  const email = (value) => {
    if (!validator.isEmail(value)) {
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid email.</div>;
    }
    
  };
  const PhoneNumber = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length > 14 || value.toString().trim().length < 8 ){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid Phone number.</div>;
    }
    // else{
    //     return <div className="validateSuccess"><i class="fa fa-check-circle"></i></div>
    // }
  };

class subData extends Component {
      constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            phone: '',
        };
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
      }
  
  handleNameChange(e) {
    this.setState({name: e.target.value}); 
  }
  handleEmailChange(e) {
    this.setState({email: e.target.value}); 
  }
  handlePhoneChange(e) {
    this.setState({phone: e.target.value}); 
  }

  handleSubmit(event) {
    event.preventDefault();
    let client_data = {
        'name': this.state.name,
        'email': this.state.email,
        'phone': this.state.phone
    }
    this.props.setSubDeliveryData(client_data);
    this.props.setSubDataComplelte();
  }

  render() {
    return (
        <div className="checkOutBody">
            <div className="panel-body" id="cash_content">
                <Form onSubmit={this.handleSubmit}>
                    <div className="inputDiv">
                        <div className="quantityDiv">
                        {
                            !this.props.quantityFormComplete?
                                <div className="quantity">
                                    <h4 className="greyFont">Quantity:</h4>
                                    <Input type="number"  placeholder="Enter the number of items"
                                        value={this.props.quantity}
                                        onChange={this.props.handelQuantityChange}
                                        validations={[required, quantityRule]}
                                        disabled
                                    />
                                    {
                                        !this.props.quantityFormComplete?
                                        <div className="quntaityControl">
                                            <button onClick = {this.props.incrementQuantity} className="plus">+</button> 
                                            <button onClick = {this.props.decrementQuantity} className="minus">-</button> 
                                        </div>
                                        :
                                        null
                                    }
                                    
                                </div>
                            :
                            <div></div>
                        }
                            
                            <div className="totalQuantity">
                                <h4 className="greyFont">Total Amount</h4>
                                <h3><label>{(this.props.total ) + ' ' + this.props.userData.currency}</label></h3>
                            </div>
                        </div>
                    </div>
                    <div className="inputDiv">
                        <h4 className="subDataTitle">
                            Perosnal Info
                        </h4>
                    </div>
                    
                    <div className="inputDiv">
                        <Input type="text" className="" name="c_pan_U" placeholder="Full Name" 
                            value={this.state.name}
                            onChange={this.handleNameChange}
                            validations={[required, FullName]}
                            class={InputStaticClass}
                            id="name"
                        />
                    </div>
                    <div className="inputDiv">
                        <Input type="text" className="" name="c_pan_U" placeholder="Email Address" 
                            value={this.state.email}
                            onChange={this.handleEmailChange}
                            validations={[required, email]}
                            class={InputStaticClass}
                            id="email"
                        />
                    </div>
                    <div className="inputDiv">
                        <Input type="number" pattern="[0-9]*" className="" name="c_pan_U" placeholder="Phone Number" 
                            value={this.state.phone} 
                            onChange={this.handlePhoneChange}
                            validations={[required, PhoneNumber]}
                            class={InputStaticClass}
                            id="Phone"
                        />
                    </div>
                    <div className='btnFooter'>
                        <Button className="btn btn-primary active premBtn">Next</Button>
                    </div>
                </Form>
            </div>
        </div>
    );
  }
}

export default subData;
